import { render, staticRenderFns } from "./FormasDePago.vue?vue&type=template&id=d1734a6c&"
import script from "./FormasDePago.vue?vue&type=script&lang=js&"
export * from "./FormasDePago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports